/**
 * @file   src\Pages\SignupProcess.tsx
 * @brief  SignupProcess page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useEffect, Container, Row, Col, useState, useOutletContext } from '../utils/thirdpartyComponents';
import SignupStepMenu from '../components/SignupStepMenu';
import BankInformation from '../components/BankInformation';
import AppSettings from '../components/AppSettings';
import LocationInformation from '../components/LocationInformation';
import OrderHardware from '../components/OrderHardware';
import "../styles/signup_process.scss";
import { AppContextType } from '../interfaces/generalInterface';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { userType } from '../utils/enums';

const stripePromise = loadStripe(process.env.REACT_APP_SUPERADMIN_STRIPE_PUBLIC_KEY || "");

const SignupProcess = () => {

    // Access the context
    const { updateData } = useOutletContext<AppContextType>();
    // Define activeStep state to show the active class
    const [activeStep, setActiveStep] = useState('bank');

    // Define completedSteps state to track which steps are completed
    const [completedSteps, setCompletedSteps] = useState<string[]>([]);

    // To display heading
    useEffect(() => {
        handleUpdate()
    }, [])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: "Car Wash Setup", url: "", showBackButton: false, showMainMenu: true, activeLink: "manage-car-wash" });
    };

    // Function to mark a step as completed
    const markStepAsCompleted = (step: string) => {
        setCompletedSteps([...completedSteps, step]);
    };

    //Function to go to next step
    const nextStep = (step: string) => {
        setActiveStep(step)
    }


    return (
        <Elements stripe={stripePromise}>
        <div className='signup-process-container'>
            <Container>
                <Row className='g-3'>
                    <Col lg={5}>
                        <SignupStepMenu activeStep={activeStep} setActiveStep={setActiveStep} completedSteps={completedSteps} cuserType={userType['SUPER-ADMIN']} />
                    </Col>
                    <Col lg={7}>
                        {activeStep === 'bank' && <BankInformation onComplete={() => {markStepAsCompleted('bank');nextStep('settings')}} cuserType={userType['SUPER-ADMIN']} />}
                        {activeStep === 'settings' && <AppSettings onComplete={() => {markStepAsCompleted('settings');nextStep('locations')}} cuserType={userType['SUPER-ADMIN']} />}
                        {activeStep === 'locations' && <LocationInformation onComplete={() => markStepAsCompleted('locations')} cuserType={userType['SUPER-ADMIN']} />}
                        {/* {activeStep === 'hardware' && <OrderHardware onComplete={() => markStepAsCompleted('hardware')} />} */}

                    </Col>
                </Row>
            </Container>
        </div>
        </Elements>
    )
}

export default SignupProcess;
